'use es6';

import * as FiscalYearRollingDateOptionsValues from 'customer-data-filters/filterQueryFormat/rollingDates/FiscalYearRollingDateOptionsValues';
import { RollingDateOptionsOrdered } from '../../filterQueryFormat/rollingDates/RollingDateOptionsOrdered';
import { Seq } from 'immutable';
import FilterOperatorErrorType from 'customer-data-filters/components/propTypes/FilterOperatorErrorType';
import I18n from 'I18n';
import InRollingDateRange from 'customer-data-filters/filterQueryFormat/operator/InRollingDateRange';
import PropTypes from 'prop-types';
import RollingDateConfig from 'customer-data-filters/filterQueryFormat/rollingDates/RollingDateConfig';
import { syntheticEvent as SyntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import memoize from 'transmute/memoize';
import { jsx as _jsx } from "react/jsx-runtime";
const createRollingDateOptions = memoize(isFiscalYearEnabled => Seq(RollingDateOptionsOrdered).filterNot(option => {
  return !isFiscalYearEnabled && FiscalYearRollingDateOptionsValues[option.value];
}).map(option => ({
  help: I18n.text(option.helpToken),
  text: I18n.text(option.textToken),
  value: option.value
})).toArray());
const FilterOperatorRollingDateRangeInput = props => {
  const {
    className,
    isFiscalYearEnabled,
    error,
    onChange,
    value
  } = props;
  const options = createRollingDateOptions(isFiscalYearEnabled);
  const isError = error.get('error');
  const errorMessage = error.get('message');
  const handleChange = evt => {
    const newValue = RollingDateConfig.fromRollingDateOptionValue(evt.target.value);
    onChange(SyntheticEvent(value.set('value', newValue)));
  };
  const rollingDateOptionValue = RollingDateConfig.toRollingDateOptionValue(value.value);
  return /*#__PURE__*/_jsx(UIFormControl, {
    "aria-label": I18n.text('customerDataFilters.FilterOperatorInput.ariaLabel'),
    error: isError,
    validationMessage: errorMessage,
    children: /*#__PURE__*/_jsx(UISelect, {
      className: className,
      onChange: handleChange,
      options: options,
      value: rollingDateOptionValue
    })
  });
};
FilterOperatorRollingDateRangeInput.propTypes = {
  className: PropTypes.string,
  error: FilterOperatorErrorType.isRequired,
  isFiscalYearEnabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.instanceOf(InRollingDateRange).isRequired
};
export default FilterOperatorRollingDateRangeInput;